/* eslint-disable */
import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";

/*------ import url and method ------*/
import * as url from "helper/UrlHelper";
import { deleteData, getData, postData, putData } from "utils/Gateway";

const NoteSection = ({
  noteAccessUserList = [],
  moduleName = "",
  leadId = null,
  contactId = null,
  invoiceId = null,
  invoiceDocId = null,
  taskId = null,
  setShowAlert = () => {},
  setAlertMessage = () => {},
  setMessageType = () => {},
}) => {
  /* ------------- Language translation imports starts here ------------- */
  const { t } = useTranslation();

  const token = localStorage.getItem("token");
  const userInfo = JSON.parse(localStorage.getItem("userInfo"));

  const params = useParams();

  const [noteTitle, setNoteTitle] = useState("");
  const [noteDetails, setNoteDetails] = useState("");
  const [isPrivate, setIsPrivate] = useState(false);
  const [isSendNotification, setIsSendNotification] = useState(false);

  const [noteList, setNoteList] = useState([]);
  const [noteIdForUpdate, setNoteIdForUpdate] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  // validation of invoice
  const [validation, setValidation] = useState({
    titleWarning: false,
    // detailsWarning: false,
  });

  // function for validation
  const validationHandler = () => {
    let isValid = true;

    if (noteTitle === "") {
      setValidation((prevState) => ({ ...prevState, titleWarning: true }));
      isValid = false;
    }

    // if (noteDetails === "") {
    //   setValidation((prevState) => ({ ...prevState, detailsWarning: true }));
    //   isValid = false;
    // }

    return isValid;
  };

  //function for get notes
  const getAllNotes = async () => {
    try {
      let requestUrl =
        url.API_BASE_URL +
        url.API_GET_ALL_NOTE +
        `?token=${token}&filternotetype=1`;

      if (leadId) {
        requestUrl += `&leadid=${leadId}`;
      }

      if (contactId) {
        requestUrl += `&contactid=${contactId}`;
      }

      if (invoiceId) {
        requestUrl += `&invoiceid=${invoiceId}`;
      }

      if (invoiceDocId) {
        requestUrl += `&invoicedocid=${invoiceDocId}`;
      }

      if (taskId) {
        requestUrl += `&taskid=${taskId}`;
      }

      const response = await getData(requestUrl);

      console.log("note response", response);

      if (response.status) {
        setNoteList(response.data);
      }
    } catch (error) {
      console.log(error.message);
    }
  };

  //function for update note
  const updateNoteStatus = (note) => {
    setNoteIdForUpdate(note._id);
    setNoteTitle(note.title);
    setNoteDetails(note.details);
    setIsPrivate(note.isprivate);
  };

  //function for save note
  const saveNoteHandler = async () => {
    console.log("noteAccessUserList", noteAccessUserList);
    if (validationHandler()) {
      try {
        setIsLoading(true);

        let noteData = {
          notetype: "1",
          title: noteTitle,
          details: noteDetails,
          isprivate: isPrivate,
          sendnotification: isSendNotification,
        };

        if (leadId) {
          noteData.leadid = leadId;
        }

        if (contactId) {
          noteData.contactid = contactId;
        }

        if (invoiceId) {
          noteData.invoiceid = invoiceId;
        }

        if (invoiceDocId) {
          noteData.invoicedocid = invoiceDocId;
        }

        if (taskId) {
          noteData.taskid = taskId;
        }

        if (isPrivate) {
          noteData.noteaccessusers = [];
        } else {
          noteData.noteaccessusers = noteAccessUserList;
        }

        let requestUrl =
          url.API_BASE_URL + url.API_ADD_NEW_NOTE + `?token=${token}`;

        const response = await postData(requestUrl, noteData);

        setIsLoading(false);

        console.log(response);

        if (response.status) {
          setMessageType("success");
          resetHandler();
          getAllNotes();
        } else {
          setMessageType("error");
        }

        setAlertMessage(response.message);
      } catch (error) {
        setAlertMessage(error.message);
        setMessageType("error");
      }
    }

    setShowAlert(true);
  };

  //function for reset note form
  const resetHandler = () => {
    setNoteTitle("");
    setNoteDetails("");
    setIsPrivate(false);
    setIsSendNotification(false);
    setNoteIdForUpdate(null);
    setValidation({
      titleWarning: false,
      detailsWarning: false,
    });
  };

  //function for update note
  const updateNoteHandler = async () => {
    try {
      setIsLoading(true);

      let noteData = {
        title: noteTitle,
        details: noteDetails,
        isprivate: isPrivate,
      };

      let requestUrl =
        url.API_BASE_URL +
        url.API_UPDATE_NOTE +
        `/${noteIdForUpdate}` +
        `?token=${token}`;

      const response = await putData(requestUrl, noteData);

      if (response.status) {
        setMessageType("success");
        resetHandler();
        getAllNotes();
      } else {
        setMessageType("error");
      }

      setIsLoading(false);
      setAlertMessage(response.message);
    } catch (error) {
      setAlertMessage(error.message);
      setMessageType("error");
    }

    setShowAlert(true);
  };

  //function for delete note
  const deleteNoteHandler = async (noteId) => {
    try {
      let requestUrl =
        url.API_BASE_URL +
        url.API_DELETE_NOTE +
        `/${noteId}` +
        `?token=${token}`;

      if (leadId) {
        requestUrl += `&leadid=${leadId}`;
      }

      if (contactId) {
        requestUrl += `&contactid=${contactId}`;
      }

      if (invoiceId) {
        requestUrl += `&invoiceid=${invoiceId}`;
      }

      if (invoiceDocId) {
        requestUrl += `&invoicedocid=${invoiceDocId}`;
      }

      if (taskId) {
        requestUrl += `&taskid=${taskId}`;
      }

      const response = await deleteData(requestUrl);

      if (response.status) {
        setMessageType("success");
        getAllNotes();
      } else {
        setMessageType("error");
      }

      setAlertMessage(response.message);
    } catch (error) {
      setAlertMessage(error.message);
      setMessageType("error");
    }

    setShowAlert(true);
  };

  useEffect(() => {
    if (leadId || contactId || invoiceId || taskId || invoiceDocId) {
      getAllNotes();
    }
  }, [leadId, contactId, invoiceId, taskId, invoiceDocId]);

  return (
    <div className="bg-white border border-gray-300 rounded-15 shadow-lg overflow-hidden">
      {/* Header Section */}
      <div
        className="px-4 py-3 border-bottom border-gray-300"
        style={{
          background:
            "linear-gradient(135deg, rgba(238, 82, 60, 0.1) 0%, rgba(255, 255, 255, 0.95) 100%)",
        }}
      >
        <div className="d-flex align-items-center gap-3">
          <div
            className="p-2 bg-primary rounded-circle d-flex align-items-center justify-content-center"
            style={{ width: "40px", height: "40px" }}
          >
            <span className="material-symbols-outlined text-white fs-md">
              note_add
            </span>
          </div>
          <div>
            <h4 className="fw-bold mb-1 text-dark">{`${t(
              "Notes"
            )} ${moduleName}`}</h4>
            <p className="fs-sm text-muted mb-0">
              {t("Add and manage notes for this item")}
            </p>
          </div>
        </div>
      </div>

      {/* Add Note Form Section */}
      <div className="p-4">
        <div className="bg-light border border-gray-300 rounded-15 p-4 mb-4">
          <div className="mb-3">
            <label className="form-label fw-semibold text-dark mb-2 d-flex align-items-center gap-2">
              <span className="material-symbols-outlined fs-sm text-primary">
                title
              </span>
              {t("Note Title")} <span className="text-danger">*</span>
            </label>
            <input
              type="text"
              className={`form-control shadow-none rounded-10 ${
                validation.titleWarning
                  ? "is-invalid"
                  : "border border-gray-300"
              }`}
              style={{
                padding: "12px 16px",
                fontSize: "0.95rem",
                transition: "all 0.3s ease-in-out",
              }}
              placeholder={t("Enter note title...")}
              value={noteTitle}
              onChange={(e) => {
                setNoteTitle(e.target.value);
                setValidation((prevState) => ({
                  ...prevState,
                  titleWarning: false,
                }));
              }}
              onFocus={(e) => {
                e.currentTarget.style.borderColor = "var(--bs-primary)";
                e.currentTarget.style.boxShadow =
                  "0 0 0 0.2rem rgba(238, 82, 60, 0.25)";
              }}
              onBlur={(e) => {
                e.currentTarget.style.boxShadow = "none";
              }}
            />
            {validation.titleWarning && (
              <div className="mt-2">
                <div
                  className="alert alert-danger border-0 rounded-10 py-2 px-3 d-flex align-items-center gap-2"
                  style={{ fontSize: "0.85rem" }}
                >
                  <span className="material-symbols-outlined fs-sm">
                    warning
                  </span>
                  <span>{t("Please enter a title!")}</span>
                </div>
              </div>
            )}
          </div>

          <div className="mb-4">
            <label className="form-label fw-semibold text-dark mb-2 d-flex align-items-center gap-2">
              <span className="material-symbols-outlined fs-sm text-primary">
                description
              </span>
              {t("Note Details")}
            </label>
            <textarea
              cols="30"
              rows="4"
              className="form-control border border-gray-300 shadow-none rounded-10"
              style={{
                padding: "12px 16px",
                fontSize: "0.95rem",
                resize: "vertical",
                minHeight: "100px",
                transition: "all 0.3s ease-in-out",
              }}
              placeholder={t("Enter note details (optional)...")}
              value={noteDetails}
              onChange={(e) => {
                setNoteDetails(e.target.value);
              }}
              onFocus={(e) => {
                e.currentTarget.style.borderColor = "var(--bs-success)";
                e.currentTarget.style.boxShadow =
                  "0 0 0 0.2rem rgba(49, 166, 30, 0.25)";
              }}
              onBlur={(e) => {
                e.currentTarget.style.boxShadow = "none";
              }}
            ></textarea>
          </div>

          {/* Form Controls and Actions */}

          {/* Checkboxes Section */}

          <div className="d-flex gap-3 flex-wrap">
            <div className="flex-grow-1">
              <div className="form-check p-3 bg-white rounded-10 border border-gray-300 h-100">
                <input
                  className="form-check-input border border-primary"
                  type="checkbox"
                  id="privateCheck"
                  checked={isPrivate}
                  onChange={(e) => setIsPrivate(e.target.checked)}
                  style={{
                    width: "18px",
                    height: "18px",
                    marginTop: "2px",
                  }}
                />
                <label
                  className="form-check-label fw-semibold text-dark ms-2"
                  htmlFor="privateCheck"
                >
                  <div className="d-flex align-items-center gap-2">
                    <span className="material-symbols-outlined fs-sm text-primary">
                      lock
                    </span>
                    {t("Mark as Private")}
                  </div>
                  <small className="text-muted d-block mt-1">
                    {t("Only you can see this note")}
                  </small>
                </label>
              </div>
            </div>

            <div className={`flex-grow-1 ${noteIdForUpdate ? "d-none" : ""}`}>
              <div className="form-check p-3 bg-white rounded-10 border border-gray-300 h-100">
                <input
                  className="form-check-input border border-primary"
                  type="checkbox"
                  id="notificationCheck"
                  checked={isSendNotification}
                  onChange={(e) => setIsSendNotification(e.target.checked)}
                  style={{
                    width: "18px",
                    height: "18px",
                    marginTop: "2px",
                  }}
                />
                <label
                  className="form-check-label fw-semibold text-dark ms-2"
                  htmlFor="notificationCheck"
                >
                  <div className="d-flex align-items-center gap-2">
                    <span className="material-symbols-outlined fs-sm text-primary">
                      notifications
                    </span>
                    {t("Send Notification")}
                  </div>
                  <small className="text-muted d-block mt-1">
                    {t("Notify relevant users")}
                  </small>
                </label>
              </div>
            </div>
          </div>

          {/* Action Buttons */}
          <div className="mt-3">
            <div className="d-flex align-items-center gap-2 justify-content-md-end">
              <button
                className={`btn btn-outline-secondary rounded-10 px-3 py-2 fw-semibold ${
                  noteIdForUpdate ? "" : "d-none"
                }`}
                style={{
                  cursor: isLoading ? "not-allowed" : "pointer",
                  transition: "all 0.3s ease-in-out",
                }}
                disabled={isLoading}
                onClick={resetHandler}
                onMouseEnter={(e) => {
                  if (!isLoading) {
                    e.currentTarget.style.backgroundColor =
                      "var(--bs-secondary)";
                    e.currentTarget.style.color = "white";
                    e.currentTarget.style.transform = "scale(1.05)";
                  }
                }}
                onMouseLeave={(e) => {
                  if (!isLoading) {
                    e.currentTarget.style.backgroundColor = "transparent";
                    e.currentTarget.style.color = "var(--bs-secondary)";
                    e.currentTarget.style.transform = "scale(1)";
                  }
                }}
              >
                <span className="material-symbols-outlined fs-sm me-1">
                  refresh
                </span>
                {t("Reset")}
              </button>

              <button
                className="btn btn-primary rounded-10 px-4 py-2 fw-bold d-flex align-items-center gap-2"
                style={{
                  cursor: isLoading ? "not-allowed" : "pointer",
                  transition: "all 0.3s ease-in-out",
                }}
                disabled={isLoading}
                onClick={noteIdForUpdate ? updateNoteHandler : saveNoteHandler}
                onMouseEnter={(e) => {
                  if (!isLoading) {
                    e.currentTarget.style.transform = "scale(1.05)";
                    e.currentTarget.style.boxShadow =
                      "0 8px 25px rgba(238, 82, 60, 0.3)";
                  }
                }}
                onMouseLeave={(e) => {
                  if (!isLoading) {
                    e.currentTarget.style.transform = "scale(1)";
                    e.currentTarget.style.boxShadow = "none";
                  }
                }}
              >
                {isLoading ? (
                  <>
                    <div
                      className="spinner-border spinner-border-sm"
                      role="status"
                    >
                      <span className="visually-hidden">Loading...</span>
                    </div>
                    <span>{t("Processing...")}</span>
                  </>
                ) : (
                  <>
                    <span className="material-symbols-outlined fs-sm">
                      {noteIdForUpdate ? "edit" : "save"}
                    </span>
                    <span>
                      {noteIdForUpdate ? t("Update Note") : t("Save Note")}
                    </span>
                  </>
                )}
              </button>
            </div>
          </div>
        </div>
      </div>
      {/* Notes List Section */}
      <div className="px-4 pb-4">
        {noteList.length > 0 ? (
          <>
            <div className="d-flex align-items-center gap-2 mb-3">
              <span className="material-symbols-outlined fs-md text-primary">
                format_list_bulleted
              </span>
              <h5 className="fw-bold mb-0 text-dark">{t("Recent Notes")}</h5>
            </div>

            <div className="notes-container">
              {noteList.map((note, index) => {
                const canEdit =
                  userInfo.role.slug === "ADMIN" ||
                  userInfo.role.slug === "SUPER_ADMIN" ||
                  note.moderator.toString() === userInfo._id.toString();

                return (
                  <div
                    className="note-card bg-white border border-gray-300 rounded-15 p-4 mb-3 shadow-sm position-relative overflow-hidden"
                    key={index}
                    style={{
                      transition: "all 0.3s ease-in-out",
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.transform = "translateY(-2px)";
                      e.currentTarget.style.boxShadow =
                        "0 8px 25px rgba(0, 0, 0, 0.1)";
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.transform = "translateY(0)";
                      e.currentTarget.style.boxShadow =
                        "0 1px 6px rgba(62, 96, 147, 0.18)";
                    }}
                  >
                    {/* Note Header */}
                    <div className="d-flex align-items-start justify-content-between mb-3">
                      <div className="flex-fill">
                        <div className="d-flex align-items-center gap-2 mb-2">
                          <div
                            className="p-2 bg-primary text-white rounded-circle d-flex align-items-center justify-content-center"
                            style={{ width: "30px", height: "30px" }}
                          >
                            <span className="material-symbols-outlined fs-sm">
                              {note.isprivate ? "lock" : "note"}
                            </span>
                          </div>
                          <h6 className="fw-bold mb-0 text-dark">
                            {note.title}
                          </h6>
                          {note.isprivate && (
                            <span className="badge bg-warning-subtle text-warning fs-xs px-2 py-1 rounded-pill">
                              {t("Private")}
                            </span>
                          )}
                        </div>
                      </div>

                      {canEdit && (
                        <div className="dropdown">
                          <button
                            className="btn btn-outline-secondary btn-sm rounded-circle d-flex align-items-center justify-content-center dropdown-toggle border-0"
                            type="button"
                            data-bs-toggle="dropdown"
                            aria-expanded="false"
                            style={{
                              width: "32px",
                              height: "32px",
                              transition: "all 0.3s ease-in-out",
                            }}
                            onMouseEnter={(e) => {
                              e.currentTarget.style.backgroundColor =
                                "var(--bs-secondary)";
                              e.currentTarget.style.color = "white";
                            }}
                            onMouseLeave={(e) => {
                              e.currentTarget.style.backgroundColor =
                                "transparent";
                              e.currentTarget.style.color =
                                "var(--bs-secondary)";
                            }}
                          >
                            <span className="material-symbols-outlined fs-sm">
                              more_vert
                            </span>
                          </button>

                          <ul
                            className="dropdown-menu dropdown-menu-end border-0 rounded-10 shadow-lg p-2"
                            style={{ minWidth: "160px" }}
                          >
                            <li>
                              <Link
                                className="dropdown-item d-flex align-items-center gap-3 py-2 px-3 rounded-8 text-decoration-none"
                                to="#"
                                onClick={() => updateNoteStatus(note)}
                                style={{
                                  transition: "all 0.3s ease-in-out",
                                }}
                                onMouseEnter={(e) => {
                                  e.currentTarget.style.backgroundColor =
                                    "rgba(238, 82, 60, 0.1)";
                                  e.currentTarget.style.transform =
                                    "translateX(5px)";
                                }}
                                onMouseLeave={(e) => {
                                  e.currentTarget.style.backgroundColor =
                                    "transparent";
                                  e.currentTarget.style.transform =
                                    "translateX(0)";
                                }}
                              >
                                <span className="material-symbols-outlined fs-sm text-primary">
                                  edit
                                </span>
                                <span className="fw-semibold">
                                  {t("Edit Note")}
                                </span>
                              </Link>
                            </li>
                            <li>
                              <Link
                                className="dropdown-item d-flex align-items-center gap-3 py-2 px-3 rounded-8 text-decoration-none"
                                to="#"
                                onClick={() => deleteNoteHandler(note._id)}
                                style={{
                                  transition: "all 0.3s ease-in-out",
                                }}
                                onMouseEnter={(e) => {
                                  e.currentTarget.style.backgroundColor =
                                    "rgba(220, 53, 69, 0.1)";
                                  e.currentTarget.style.transform =
                                    "translateX(5px)";
                                }}
                                onMouseLeave={(e) => {
                                  e.currentTarget.style.backgroundColor =
                                    "transparent";
                                  e.currentTarget.style.transform =
                                    "translateX(0)";
                                }}
                              >
                                <span className="material-symbols-outlined fs-sm text-danger">
                                  delete
                                </span>
                                <span className="fw-semibold text-danger">
                                  {t("Delete Note")}
                                </span>
                              </Link>
                            </li>
                          </ul>
                        </div>
                      )}
                    </div>

                    {/* Note Content */}
                    <div className="note-content">
                      <div className="d-flex align-items-center gap-2 mb-2">
                        <span className="material-symbols-outlined fs-sm text-muted">
                          schedule
                        </span>
                        <small className="text-muted fw-semibold">
                          {note.notedate}
                        </small>
                      </div>
                      {note.details && (
                        <p
                          className="text-dark mb-0 lh-base"
                          style={{ fontSize: "0.95rem" }}
                        >
                          {note.details}
                        </p>
                      )}
                    </div>
                  </div>
                );
              })}
            </div>
          </>
        ) : (
          <div className="text-center py-5">
            <div
              className="p-4 bg-light rounded-circle d-inline-flex align-items-center justify-content-center mb-3"
              style={{ width: "80px", height: "80px" }}
            >
              <span
                className="material-symbols-outlined text-muted"
                style={{ fontSize: "2rem" }}
              >
                note_add
              </span>
            </div>
            <h6 className="fw-bold text-muted mb-2">{t("No Notes Yet")}</h6>
            <p className="text-muted mb-0">
              {t("Add your first note using the form above")}
            </p>
          </div>
        )}
      </div>
    </div>
  );
};

export default NoteSection;
